export enum ALLOWED_FILE_PREVIEW_EXTENTIONS {
  JPEG = 'jpeg',
  JPG = 'jpg',
  MP4 = 'mp4',
  PDF = 'pdf',
  PNG = 'png',
}
